import styled from 'styled-components';
import {insightsItem, progressWrapper, section, title} from '../../windowItems/windowItems.css';
import {dFlexColumn} from '../../../../../globalVariables/GlobalFlex';
import {mobileMedia} from '../../../../../globalVariables/GlobalVariables';

export const container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding: 20px;
  padding-bottom: 5px;
`;
export const content = styled.div`
  display: flex;
  justify-content: space-between;
  width: calc(100% - 30px);
  gap: 15px;
  ${section}{
    flex: 1;
    min-width: 50%;
    padding-inline: 0;
  }
  ${title}{
    min-width: max-content;
  }
`;
export const texts = styled.div`
  ${dFlexColumn}
  gap: 5px;
`;

export const insights = styled.div`
  padding-bottom: 5px;
  height: 50%;
  justify-content: space-between;
  border-radius: 8px;
  display: flex;
  align-items: flex-end;
  ${progressWrapper}{
    height: 90px;
    ${mobileMedia}{
      height: 75px;
    }
  }
`;
export const insightsNumbers = styled.div<{$eventType?: string; }>`
  height: 98%;
  display: flex;
  flex-direction: column;
  justify-content: ${p=> p.$eventType === 'area'? 'space-between' : 'flex-end'};
  ${insightsItem} {
    margin-bottom: 3px;
  }
`;
